import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import Button from "src/components/Form/Button";
import { useState } from "react";
import DoubleTextInput from "src/components/Form/DoubleTextInput";
import CustomOptionSelect from "src/components/Form/CustomOptionSelect";
import CustomOptionSingleSelect from "src/components/Form/CustomOptionSingleSelect";
import CustomOptionBox from "src/components/Form/CustomOptionBox";
import CheckBox from "src/components/Form/CheckBox";
import Option from "src/components/Form/Option";
import TextInput from "src/components/Form/TextInput";
import useFormFields from "src/hooks/useFormFields";
import EnhanceSelectBox from "src/components/Form/EnhanceSelectBox";
import FormCheckbox from "src/components/Form/FormCheckbox";
import Subheading from "src/components/Subheading";
import usePersistantState from "src/hooks/usePersistantState";
import React from 'react'
import CreatableSelect from 'react-select/creatable';

const options = [
    { value: 'مهندسی برق', label: 'مهندسی برق' },
    { value: 'مهندسی کامپیوتر', label: 'مهندسی کامپیوتر' },
    { value: 'مهندسی مکانیک', label: 'مهندسی مکانیک' },
    { value: 'مهندسی عمران', label: 'مهندسی عمران' },
    { value: 'مهندسی معماری', label: 'مهندسی معماری' },
    { value: 'مهندسی کشتی', label: 'مهندسی کشتی' },
    { value: 'مهندسی هوافضا', label: 'مهندسی هوافضا' },
    { value: 'مهندسی انرژی', label: 'مهندسی انرژی' },
    { value: 'مهندسی شهرسازی', label: 'مهندسی شهرسازی' },
    { value: 'مهندسی فناوری اطلاعات', label: 'مهندسی فناوری اطلاعات' },
    { value: 'مهندسی صنایع', label: 'مهندسی صنایع' },
    { value: 'مهندسی پزشکی', label: 'مهندسی پزشکی' },
    { value: 'مهندسی نساجی', label: 'مهندسی نساجی' },
    { value: 'مهندسی رباتیک', label: 'مهندسی رباتیک' },
    { value: 'مهندسی نفت', label: 'مهندسی نفت' },
    { value: 'مهندسی ایمنی', label: 'مهندسی ایمنی' },
    { value: 'مهندسی معدن', label: 'مهندسی معدن' },
    { value: 'مهندسی پلیمر', label: 'مهندسی پلیمر' },
    { value: 'مهندسی مواد', label: 'مهندسی مواد' },
    { value: 'مهندسی مدیریت پروژه', label: 'مهندسی مدیریت پروژه' },
    { value: 'مهندسی راه‌آهن', label: 'مهندسی راه‌آهن' },
    { value: 'مهندسی کشاورزی', label: 'مهندسی کشاورزی' },
    { value: 'علوم مهندسی', label: 'علوم مهندسی' },
    { value: 'معماری داخلی', label: 'معماری داخلی' },
    { value: 'کاردان فنی مکانیک', label: 'کاردان فنی مکانیک' },
    { value: 'کاردان فنی عمران', label: 'کاردان فنی عمران' },
    { value: 'کاردان فنی برق', label: 'کاردان فنی برق' },
    { value: 'کاردانی هواپیما', label: 'کاردانی هواپیما' },
    { value: 'کاردان فنی معدن', label: 'کاردان فنی معدن' },
    { value: 'مکاترونیک', label: 'مکاترونیک' },
    { value: 'علوم کامپیوتر', label: 'علوم کامپیوتر' },
    { value: 'شیمی', label: 'شیمی' },
    { value: 'حسابداری', label: 'حسابداری' },
    { value: 'فیزیک', label: 'فیزیک' },
    { value: 'فیزیک مهندسی', label: 'فیزیک مهندسی' },
    { value: 'ریاضیات و کاربردها', label: 'ریاضیات و کاربردها' },
    { value: 'کارشناسی چندرسانه‌ای', label: 'کارشناسی چندرسانه‌ای' },
    { value: 'مهندسی بازرسی فنی', label: 'مهندسی بازرسی فنی' },
    { value: 'مهندسی ماشین‌های کشاورزی', label: 'مهندسی ماشین‌های کشاورزی' },
    { value: 'هوانوردی', label: 'هوانوردی' },
    { value: 'مهندسی مدیریت اجرایی', label: 'مهندسی مدیریت اجرایی' },
    { value: 'مهندسی مواد و طراحی صنایع غذایی', label: 'مهندسی مواد و طراحی صنایع غذایی' },
    { value: 'مهندسی مکانیک نیروگاه', label: 'مهندسی مکانیک نیروگاه' },
    { value: 'خلبانی هلیکوپتر', label: 'خلبانی هلیکوپتر' },
    { value: 'مهندسی فرماندهی و کنترل هوایی', label: 'مهندسی فرماندهی و کنترل هوایی' },
    { value: 'مهندسی اپتیک و لیزر', label: 'مهندسی اپتیک و لیزر' },
    { value: 'پزشکی', label: 'پزشکی' },
    { value: 'دندان‌پزشکی', label: 'دندان‌پزشکی' },
    { value: 'داروسازی', label: 'داروسازی' },
    { value: 'بیوتکنولوژی', label: 'بیوتکنولوژی' },
    { value: 'دام‌پزشکی', label: 'دام‌پزشکی' },
    { value: 'زیست‌شناسی', label: 'زیست‌شناسی' },
    { value: 'فیزیوتراپی', label: 'فیزیوتراپی' },
    { value: 'اعضای مصنوعی', label: 'اعضای مصنوعی' },
    { value: 'بهداشت مواد غذایی', label: 'بهداشت مواد غذایی' },
    { value: 'مدیریت و کمیسر دریایی', label: 'مدیریت و کمیسر دریایی' },
    { value: 'تکنسین پروتزهای دندانی', label: 'تکنسین پروتزهای دندانی' },
    { value: 'تکنولوژی مرتع و آبخیزداری', label: 'تکنولوژی مرتع و آبخیزداری' },
    { value: 'آرگونومی', label: 'آرگونومی' },
    { value: 'اتاق عمل', label: 'اتاق عمل' },
    { value: 'هوش‌بری', label: 'هوش‌بری' },
    { value: 'بینایی‌سنجی', label: 'بینایی‌سنجی' },
    { value: 'شنوایی‌شناسی', label: 'شنوایی‌شناسی' },
    { value: 'علوم آزمایشگاهی', label: 'علوم آزمایشگاهی' },
    { value: 'علوم آزمایشگاهی دام‌پزشکی', label: 'علوم آزمایشگاهی دام‌پزشکی' },
    { value: 'مامایی', label: 'مامایی' },
    { value: 'علوم تغذیه', label: 'علوم تغذیه' },
    { value: 'علوم و صنایع غذایی', label: 'علوم و صنایع غذایی' },
    { value: 'مهندسی بهداشت محیط', label: 'مهندسی بهداشت محیط' },
    { value: 'مهندسی فضای سبز', label: 'مهندسی فضای سبز' },
    { value: 'کارشناسی بهداشت عمومی', label: 'کارشناسی بهداشت عمومی' },
    { value: 'مهندسی منابع طبیعی', label: 'مهندسی منابع طبیعی' },
    { value: 'کاردانی دام‌پزشکی', label: 'کاردانی دام‌پزشکی' },
    { value: 'پرستاری', label: 'پرستاری' },
    { value: 'مدارک پزشکی', label: 'مدارک پزشکی' },
    { value: 'زیست‌شناسی سلولی', label: 'زیست‌شناسی سلولی' },
    { value: 'مهندسی بهداشت حرفه‌ای', label: 'مهندسی بهداشت حرفه‌ای' },
    { value: 'مهندسی تولیدات گیاهی', label: 'مهندسی تولیدات گیاهی' },
    { value: 'فناوری اطلاعات سلامت', label: 'فناوری اطلاعات سلامت' },
    { value: 'علوم مهندسی زیست‌محیطی', label: 'علوم مهندسی زیست‌محیطی' },
    { value: 'دبیری شیمی', label: 'دبیری شیمی' },
    { value: 'شیمی', label: 'شیمی' },
    { value: 'گفتاردرمانی', label: 'گفتاردرمانی' },
    { value: 'تکنولوژی تولیدات دامی', label: 'تکنولوژی تولیدات دامی' },
    { value: 'فوریت‌های پزشکی', label: 'فوریت‌های پزشکی' },
    { value: 'شیلات', label: 'شیلات' },
    { value: 'زراعت و اصلاح نباتات', label: 'زراعت و اصلاح نباتات' },
    { value: 'علوم دامی', label: 'علوم دامی' },
    { value: 'اقیانوس‌شناسی', label: 'اقیانوس‌شناسی' },
    { value: 'زمین‌شناسی', label: 'زمین‌شناسی' },
    { value: 'کاردرمانی', label: 'کاردرمانی' },
    { value: 'علوم و صنایع غذایی', label: 'علوم و صنایع غذایی' },
    { value: 'رادیولوژی', label: 'رادیولوژی' },
    { value: 'ایمونولوژی', label: 'ایمونولوژی' },
    { value: 'پزشکی هسته‌ای', label: 'پزشکی هسته‌ای' },
    { value: 'ترویج و آموزش کشاورزی', label: 'ترویج و آموزش کشاورزی' },
    { value: 'مهندسی چوب', label: 'مهندسی چوب' },
    { value: 'جنگل‌داری', label: 'جنگل‌داری' },
    { value: 'پدافند جنگ‌های میکروبی', label: 'پدافند جنگ‌های میکروبی' },
    { value: 'پرورش زنبور عسل', label: 'پرورش زنبور عسل' },
    { value: 'بهره‌برداری گیاهان دارویی', label: 'بهره‌برداری گیاهان دارویی' },
    { value: 'حقوق', label: 'حقوق' },
    { value: 'کارشناسی ارشد الهیات', label: 'کارشناسی ارشد الهیات' },
    { value: 'مطالعات ارتباطی', label: 'مطالعات ارتباطی' },
    { value: 'علوم اقتصادی', label: 'علوم اقتصادی' },
    { value: 'مدیریت', label: 'مدیریت' },
    { value: 'علوم سیاسی', label: 'علوم سیاسی' },
    { value: 'علوم قضایی', label: 'علوم قضایی' },
    { value: 'تربیت بدنی', label: 'تربیت بدنی' },
    { value: 'علوم اجتماعی', label: 'علوم اجتماعی' },
    { value: 'تفسیر قرآن مجید', label: 'تفسیر قرآن مجید' },
    { value: 'روان‌شناسی', label: 'روان‌شناسی' },
    { value: 'زبان و ادبیات فارسی', label: 'زبان و ادبیات فارسی' },
    { value: 'زبان و ادبیات عربی', label: 'زبان و ادبیات عربی' },
    { value: 'روابط عمومی', label: 'روابط عمومی' },
    { value: 'مطالعات خانواده', label: 'مطالعات خانواده' },
    { value: 'کتابداری', label: 'کتابداری' },
    { value: 'مددکاری اجتماعی', label: 'مددکاری اجتماعی' },
    { value: 'راهنمایی و مشاوره', label: 'راهنمایی و مشاوره' },
    { value: 'ادبیات داستانی', label: 'ادبیات داستانی' },
    { value: 'ژئومورفولوژی', label: 'ژئومورفولوژی' },
    { value: 'جغرافیا', label: 'جغرافیا' },
    { value: 'مدیریت هتل‌داری', label: 'مدیریت هتل‌داری' },
    { value: 'علوم تربیتی', label: 'علوم تربیتی' },
    { value: 'مدیریت جهان‌گردی', label: 'مدیریت جهان‌گردی' },
    { value: 'دبیری جغرافیا', label: 'دبیری جغرافیا' },
    { value: 'امور گمرکی', label: 'امور گمرکی' },
    { value: 'تاریخ', label: 'تاریخ' },
    { value: 'علوم حدیث', label: 'علوم حدیث' },
    { value: 'فلسفه', label: 'فلسفه' },
    { value: 'پرورش کودکان پیش‌دبستانی', label: 'پرورش کودکان پیش‌دبستانی' },
    { value: 'دبیری زبان و ادبیات عربی', label: 'دبیری زبان و ادبیات عربی' },
    { value: 'مدیریت - بازرگانی دریایی', label: 'مدیریت - بازرگانی دریایی' },
    { value: 'علوم ارتباطات اجتماعی', label: 'علوم ارتباطات اجتماعی' },
    { value: 'الهیات و معارف اسلامی', label: 'الهیات و معارف اسلامی' },
    { value: 'سینما', label: 'سینما' },
    { value: 'عکاسی', label: 'عکاسی' },
    { value: 'چاپ', label: 'چاپ' },
    { value: 'کارشناسی فرش', label: 'کارشناسی فرش' },
    { value: 'گرافیک', label: 'گرافیک' },
    { value: 'صنایع دستی', label: 'صنایع دستی' },
    { value: 'موزه‌داری', label: 'موزه‌داری' },
    { value: 'باستان‌شناسی', label: 'باستان‌شناسی' },
    { value: 'مرمت آثار تاریخی', label: 'مرمت آثار تاریخی' },
    { value: 'تلویزیون و هنرهای دیجیتال', label: 'تلویزیون و هنرهای دیجیتال' },
    { value: 'زبان انگلیسی', label: 'زبان انگلیسی' },
    { value: 'زبان فرانسوی', label: 'زبان فرانسوی' },
    { value: 'زبان روسی', label: 'زبان روسی' },
    { value: 'زبان چینی', label: 'زبان چینی' },
    { value: 'زبان آلمانی', label: 'زبان آلمانی' },
];

export default function JobAnalysisPage2({ handleStep, handleStepDown }) {

    // ReshteTahsili
    const [selectedOption, setSelectedOption] = usePersistantState("reshteTahsili", []);
    // Handler for changes
    const handleSelect = (selected) => {
        // Update the state with the selected item(s)
        setSelectedOption(selected);
    };
    // ReshteTahsili

    const [tasks, setTasks] = usePersistantState("salahiatha", []);
    const [change, setChange] = useState(true);
    const [education, setEducation] = usePersistantState("education", {
        "کمتر از دیپلم": false,
        "دیپلم": false,
        "فوق دیپلم": false,
        "لیسانس": false,
        "فوق لیسانس": false,
        "دکتری": false,
        "پسا دکتری": false
    });
    const [experience, setExperience] = usePersistantState("experience", {
        "بدون سابقه": false,
        "حداقل یک سال سابقه کاری مرتبط": false,
        "حداقل دو سال سابقه کاری مرتبط": false,
        "حداقل سه سال سابقه کاری مرتبط": false,
        "حداقل چهار سال سابقه کاری مرتبط": false,
        "حداقل پنج سال سابقه کاری مرتبط": false,
        "حداقل شش سال سابقه کاری مرتبط": false,
        "حداقل هفت سال سابقه کاری مرتبط": false,
        "حداقل هشت سال سابقه کاری مرتبط": false,
        "حداقل نه سال سابقه کاری مرتبط": false,
        "حداقل ده سال سابقه کاری مرتبط": false,
    });

    const addTask = () => {
        if (taskInputs.length < 9) {
            const newTasks = tasks;
            newTasks.push((tasks.length) + 1);
            setTasks(newTasks);
            setChange(!change);
        }
    }

    const [vijegihayeJesmi, setVijegihayeJesmi] = usePersistantState("vijegihayeJesmi", {
        "بینایی کامل": {
            value: {},
            desc: ""
        },
        "شنوایی": {
            value: {},
            desc: ""
        },
        "بویایی": {
            value: {},
            desc: ""
        },
        "قدرت بدنی": {
            value: {},
            desc: ""
        },
        "عدم نقص عضو": {
            value: {},
            desc: ""
        },
        "تکلم و قدرت بیان": {
            value: {},
            desc: ""
        },
        "دویدن": {
            value: {},
            desc: ""
        },
        "تشخیص رنگ‌ها": {
            value: {},
            desc: ""
        },
        "تناسب اندام": {
            value: {},
            desc: ""
        },
    })
    // const [vijegihayeZehni, setVijegihayeZehni] = usePersistantState("vijegihayeZehni", {
    //     "شغل مستلزم کاربرد مهارتها و روشهای ساده و تکراری بوده، نیاز به دقت و تمرکز حواس داشته و با ابزار اندازهگیری ساده سروکار دارد": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم کاربرد مهارتها و روشهای متعدد و پیچیده ای بوده نیاز به دقت و تمرکز حواس زیاد داشته و با ابزار اندازه گیری پیچیده سروکار دارد": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم تجزیه و تحلیل مسائل و روشهای مختلف بوده نیاز به اتخاذ تصمیم برای تغییر و یا اصالح روشها دارد.": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم طراحی، تهیه و تدوین روش های مختلف بوده و با مسائل پیچیده مواجه بوده و نیاز به ابتکار خلاقیت، قضاوت و تصمیم گیری دارد": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم مواجه با مسائل و مشکلات پیچیده ای است و نیاز به برنامه ریزی و اتخاذ تصمیم در حد واحد سازمانی دارد": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم اتخاذ تصمیم در موارد مختلف و تدوین برنامه و خط مشی برای واحدهای مختلف سازمانی می باشد.": {
    //         value: {},
    //         desc: ""
    //     },
    //     "شغل مستلزم اتخاذ تصمیم های حساس مدیریتی، ترسیم چشم انداز، اهداف و استراتژی های کلان سازمانی می باشد": {
    //         value: {},
    //         desc: ""
    //     },
    // })




    // const [shakhesRaftari, setShakhesRaftari] = useState({
    //     "1- به آراستگی ظاهر و حفظ بهداشت خود اهتمام می ورزد.": {},
    //     "2- درصدد ارتقاء دانش شغلی خود بوده و به یادگیری و كسب معلومات جدید اهتمام می ورزد": {},
    //     "3- در محیط كار و در انجام تكالیف اداری به مقامات مافوق احترام می گذارد": {},
    //     "4- گوش دادن به انتقاد های دیگران ، تجزیه و تحلیل منطقی و برخورد مناسب با نقطه نظرات مخالف و پذیرش ایده های سازنده": {},
    //     "5- از انعطاف كافی برای انجام وظایف فوقالعاده حتی در خارج از ساعات كاری برخوردار است": {},
    //     "6- با مقامات مافوق، همتراز و همكاران و همچنین با ارباب رجوع رفتاری مودبانه، مسئوالنه و متعهدانه دارد.": {},
    //     "7- اعتقاد به اینكه سازمان وی مفید بوده و نسبت به آن احساس تعلق می نماید.": {},
    //     "8- دارای ابتكار و خالقیت كافی در حل مسائل و مشكالت میباشد و در راه پیشبرد اهداف و ماموریتهای سازمان از آن به خوبی استفاده می نماید.": {},
    //     "9- در انجام تكالیف محوله ضمن رازداری، از اسناد و مدارك سازمانی در اختیار حفاظت نموده و از افشای اطالعات محرمانه خودداری می نماید.": {},
    //     "10- از كار تیمی استقبال نموده و به عنوان عضو فعال در تیم به انجام وظایف محوله می پردازد.": {},
    //     "11- در مورد تصمیمات و عملكرد خود اعتماد كامل دارد.": {},
    //     "12- معلومات، اطالعات و تجارب خود را در اختیار دیگر همكاران قرار می دهد": {},
    //     "13- در مقابل تصمیمات و عملكرد خود پاسخگو می باشد.": {},
    //     "14- در برخورد با مافوق، همكاران و ارباب رجوع از خود نكتهسنجی، بصیرت و مالحظه نشان می دهد.": {},
    //     "15- از مقررات، دستورالعملها و روشهای سازمان آگاه است و آنها را بصورت موثر بكار می گیرد.": {},
    //     "16- مسئولیتهای سازمانی، گروهی و فردی را بطور كامل درك نموده و خود را درقبال وظایف محوله مسئول دانسته ،پیگیری و تالش می كند": {},
    //     "17- بر اساس شایستهساالری، زمینههای الزم برای رشد، ارتقاء و تفویض اختیار كاركنان تحت سرپرستی خود را فراهم می سازد.": {},
    //     "18- با حضور بموقع و موثر در جلسات با آمادگی قبلی راهكارهای موثر، نظرات اصالحی، ارشادی و انتقادی سازنده خود را ابراز می دارد.": {},
    //     "19- ضمن برخورداری از دقت كافی دارای شخصیت مثبت، امیدوار و سازنده است.": {},
    //     "20- وظایف كاركنان و انتظارات خود را از افراد تحت سرپرستی به روشنی تبیین نموده و اهداف، كمیت و كیفیت امور را به طور شفاف مشخص می نماید.": {},
    //     "21- به مشورت اعتقاد دارد و از تجارب و دانش همكاران و مشاوران داخل و یا خارج از سازمان در حل مسایل استفاده موثر به عمل می آورد": {},
    //     "22- از وسائل و تجهیزات در اختیار برای انجام وظایف خود با دقت و طبق اصول مربوطه استفاده می نماید.": {},
    //     "23- در انجام وظایف محوله، زمان انجام كار را مدنظر قرار داده و آنها را به موقع انجام می دهد.": {},
    //     "24- با شرح وظایف و دستورالعملهای مرتبط با شغل خود آشنا بوده و در جهت انجام و رعایت آنها اهتمام می ورزد": {},
    //     "25- مقدار كار محوله را طبق انتظارات مافوق و بدون اعتراض، در موعد مقرر به انجام می رساند.": {},
    //     "26- كارهای محوله را بطور كامل و صحیح و مطابق با انتظارات و باكیفیت مطلوب به انجام می رساند": {},
    //     "27- گزارش های تحلیلی و مقایسه ای مورد نیاز مقامات سازمان را با دقت و شفافیت الزم و بموقع تهیه و در اختیار آنان قرار می دهد.": {},
    //     "28- از شبكههای اطالعرسانی و سایر منابع، اطالعات دقیق را كسب و ضمن ارتقاء سطح دانش خود برای انجام وظایف محوله از آنها استفاده می نماید.": {},
    //     "29- با استفاده از تجربه و مهارت خود و تجزیه و تحلیل مطالب و تهیه گزارش مناسب، زمینه الزم را برای تصمیم گیری مقامات مافوق فراهم می سازد.": {},
    //     "30- اهمیت و اولویت موضوعات سازمان را به خوبی تشخیص داده و در انجام وظایف آنها را رعایت می نماید": {},
    //     "31- از دانش فنی و تخصصی خود به نحو مطلوبی در جهت تجزیه و تحلیل مسائل و ارائه راهكارهای عملیاتی استفاده می نماید.": {},
    //     "32- در انجام فعالیت ها و وظایف محوله از دانش علمی و عملی خود استفاده بهینه به عمل می آورد.": {},
    //     "33- روشهای مناسب را برای افزایش انگیزش همكاران تحت نظارت خود اعمال می نماید.": {},
    //     "34- در انجام فعالیتها و وظایف محوله از دانش علمی و عملی خود استفاده بهینه به عمل می آورد": {},
    //     "35- از دانش علمی و نظری مورد نیاز برخوردار است و آن را در انجام وظایف محوله به شكل موثر بكار می برد": {},
    //     "36- با سیستمها و روشهای عملیاتی و اطالعاتی موجود آشنایی كافی داشته و در مواقع لزوم پیشنهادات سازنده خود را در جهت بهبود آنها ارائه می نماید": {},
    //     "37- در برخورد با مسایل، تصمیمات مناسب را اتخاذ مینماید، فوریتها را تشخیص داده و عكسالعمل الزم را از خود بروز می دهد.": {},
    //     "38- در اجرای تصمیمات منطبق با واقعیتها و منافع سازمان، راسخ بوده و از جدیت كافی برخوردار می باشد.": {},
    //     "39- از پیشرفت برنامهها و اهداف تعیین شده و میزان دستیابی آنها آگاه بوده و در مواقع لزوم نسبت به اصالح انحرافات به نحو موثر اقدام می نماید": {},
    //     "40- توان تشخیص به موقع لزوم تغییرات و تحوالت و اعمال روشهای جدید را دارد.": {},
    //     "41- پیش بینی و زمانبندی دقیق فعالیت ها مطابق اهداف تعیین شده و تخصیص منابع مناسب": {},
    //     "42- اهداف تعیین شده سازمانی را به خوبی درك نموده و درجهت پیشبرد آنها تالش موثر مبذول می دارد.": {},
    //     "43- با دیدی جامع و استراتژیک مسائل را تحلیل نموده و در آینده مناسبی را برای سازمان یا حوزه كاری خود ترسیم می نماید.": {},
    // })




    const { fields, handleChange } = useFormFields({
        value: {},
        desc: ""
    }, "formFieldSalahiatha")


    const handleDelete = (index) => {
        let newTask = tasks;
        newTask.splice(index, 1);
        setTasks(newTask);
        setChange(!change);
    }
    const taskInputs = tasks.map((task, index) => {
        if (index + 1 == tasks.length) {
            return (<TextInput inputName={`صلاحیت حرفه‌ای ${index + 2}`} value={fields[`صلاحیت حرفه‌ای ${index + 2}`]} key={index} placeholder={`صلاحیت ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} isLast={true} />)
        } else {
            return (<TextInput inputName={`صلاحیت حرفه‌ای ${index + 2}`} value={fields[`صلاحیت حرفه‌ای ${index + 2}`]} key={index} placeholder={`صلاحیت ${index + 2}`} handleChange={handleChange} handleDelete={handleDelete} />)
        }
    })



    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={2} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">
                <div className="bg-gray-100 mb-9 -m-10 rounded-lg p-4 font-semibold text-lg">شرایط احراز شغل</div>

                <div className="relative cursor-pointer w-full">
                    <EnhanceSelectBox state={education} setState={setEducation} label="حداقل تحصیلات" />
                </div>

                <div className="relative cursor-pointer mb-6">
                    <div className="flex w-full items-center">
                        <span className="w-[130px] mr-4 text-gray-600">رشته تحصیلی</span>
                        <CreatableSelect
                            value={selectedOption}
                            onChange={handleSelect}
                            isMulti
                            className="w-full border-2 border-gray-400 rounded-lg"
                            options={options}
                            placeholder="رشته‌های تحصیلی مرتبط را انتخاب کنید (می‌توانید چند رشته را انتخاب کنید)" />
                    </div>
                </div>

                <div className="relative cursor-pointer">
                    <EnhanceSelectBox state={experience} setState={setExperience} label="میزان سابقه:" placeholder="حداقل میزان سابقه مورد نیاز برای شغل" />
                </div>




                <Subheading title="ویژگی‌های جسمی مورد نیاز" />
                <FormCheckbox state={vijegihayeJesmi} setState={setVijegihayeJesmi} />


                {/* <Subheading title="ویژگی‌های ذهنی مورد نیاز" />
                <FormCheckbox state={vijegihayeZehni} setState={setVijegihayeZehni} newButtonLabel="افزودن مورد جدید" /> */}


                {/* <Subheading title="شاخص‌های ارزشیابی عملکرد" />
                <FormCheckbox state={shakhesRaftari} setState={setShakhesRaftari} newButtonLabel="افزودن مورد جدید" /> */}


                <Subheading title="صلاحیت‌های حرفه‌ای، مجوزها و گواهینامه‌های مورد نیاز شغل" />
                <div className="mt-10">
                    <TextInput value={fields[`صلاحیت حرفه‌ای ${1}`]} placeholder="مثال: پروانه سازمان نظام روانشناسی، پروانه طبابت سازمان نظام پزشکی ،  گواهینامه رانندگی،  مجوز وکالت و..." inputName="صلاحیت حرفه‌ای 1" handleChange={handleChange} />
                </div>
                <div className="">
                    {taskInputs}
                </div>
                <div className="flex items-center mb-5">
                    <div className="inline-block text-right text-gray-500"></div>
                    <button onClick={addTask}
                        className="flex w-[200px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300">
                        <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">+</span>
                        اضافه کردن صلاحیت
                    </button>
                </div>


                <div className="flex flex-row justify-center items-center mt-10">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل فرم بعدی" direction="center" handleClick={(event) => handleStep()} color="#5B5CFF" />
                </div>
            </div>
        </PanelLayout>
    )
}